import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@repo/ui-primitives';
export function ApplicationListSkeleton() {
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-4",
        children: Array.from({
            length: 4
        }).map((_, index)=>/*#__PURE__*/ _jsxs("div", {
                className: "flex items-start justify-between rounded-lg border border-border bg-card p-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1 space-y-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-6 w-48"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-7 w-12"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-64"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-4 w-16"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-4 w-16"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-4 w-28"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-9 w-9 rounded-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-9 w-9 rounded-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-9 w-9 rounded-full"
                            })
                        ]
                    })
                ]
            }, index))
    });
}
